import CompareIcon from '@mui/icons-material/Compare';
import MovieIcon from '@mui/icons-material/Movie';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
  Typography,
  styled,
} from '@mui/material';
import clockTime from 'clock-time';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {Link as RouterLink} from 'react-router';
import {ASSETS_URL} from '../../../config.js';
import {ASPECT_RATIO} from '../../../constants.js';
import {theme} from '../../../styles.js';
import StoryMenu from './story-menu.jsx';

const LinkButton = React.forwardRef((props, ref) => (
  <RouterLink ref={ref} {...props} />
));

const Media = styled(CardMedia)({
  height: 0,
  paddingTop: `${(1 / ASPECT_RATIO) * 100}%`,
  backgroundColor: theme.palette.common.black,
});

const StyledCardContent = styled(CardContent)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

const CardContentText = styled('div')({
  flexGrow: 1,
  overflow: 'hidden',
});

const Subheading = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'pre',
});

class StoryCard extends Component {
  static propTypes = {
    story: PropTypes.object.isRequired,
  };

  renderStoryLength() {
    if (this.props.story.format !== 'mp4') {
      return null;
    }

    const storyLength = this.props.story.frames.length / this.props.story.rate;
    return (
      <Fragment>
        <span> / </span>
        <span title={`${Math.round(storyLength)} seconds`}>
          {clockTime(storyLength * 1000)}
        </span>
      </Fragment>
    );
  }

  render() {
    const createdDate = new Date(this.props.story.created);
    const detailLink = `/${this.props.story.id}`;

    return (
      <Fragment>
        <Card data-cy="story-card" sx={{position: 'relative'}}>
          <CardActionArea component={LinkButton} to={detailLink}>
            <Media
              image={`${ASSETS_URL}/${this.props.story.id}/frame-000.png`}
              title={this.props.story.title}
              data-cy="story-image"
            />
          </CardActionArea>

          <StyledCardContent>
            <CardContentText>
              <Link
                color="inherit"
                component={RouterLink}
                data-cy="story-title"
                noWrap
                sx={{
                  display: 'block',
                  marginBottom: 1,
                }}
                title={this.props.story.title}
                to={detailLink}
                underline="hover"
                variant="body1"
              >
                {this.props.story.title.trim() || <i>Untitled</i>}
              </Link>

              <Subheading variant="caption" color="textSecondary">
                {this.props.story.format === 'mp4' ? (
                  <MovieIcon fontSize="small" />
                ) : (
                  <CompareIcon fontSize="small" />
                )}
                <span
                  title={format(createdDate, "MMMM d, yyyy 'at' h:mm a")}
                  data-cy="story-date-label"
                  style={{marginLeft: 4}}
                >
                  {format(createdDate, 'MMMM d, yyyy')}
                </span>
                {this.renderStoryLength()}
              </Subheading>
            </CardContentText>

            {this.props.story.own && <StoryMenu story={this.props.story} />}
          </StyledCardContent>
        </Card>
      </Fragment>
    );
  }
}

export default StoryCard;
